import { ProductActionsBodyCell } from './ProductActionsBodyCell';
import { useActionsColumn } from '../../../../components/columns/actions';

export function useProductActionsColumn() {
  return useActionsColumn({
    render: (text, row) => <ProductActionsBodyCell row={row} />,
  });
}
